'use client';

import { css } from '@linaria/core';

export const root = css`
  position: relative;
`;

export const empty = css`
  ins {
    display: none;
  }
`;

export const loading = css`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;
